module.exports = __webpack_public_path__ + "static/media/Braga_largodopaco.097af571.jpg";